import React from 'react'
import PropTypes from 'prop-types'

const InputRow = (props) => {
    const hasErrors = () => {
        if (typeof (props.errors) === 'object') {
            return props.errors && props.errors[props.name]
        } else {
            return props.errors && props.errors !== ''
        }
    }

    const Errors = () => {
        if (typeof (props.errors) === 'object') {
            return (
                <div className='inline-error'>{props.errors[props.name][0]}</div>
            )
        } else {
            return (
                <div className='inline-error'>{props.errors}</div>
            )
        }
    }

    return (
        <div style={{ width: `${props.width}%` }}>
            <div className='form-control my-4 my-md-3'>
                {props.hideLabel
                    ? ''
                    : <label>
                        <span dangerouslySetInnerHTML={{ __html: props.label }} />
                        <br />
                        {props.children}
                    </label>}
                <div style={props.hideLabel ? { width: '100%' } : {}}>
                    <input
                        name={props.name}
                        value={props.value ? props.value : ''}
                        type={props.type ? props.type : 'text'}
                        placeholder={props.placeholder ? props.placeholder : ''}
                        className={`${props.className ? props.className : ''} ${hasErrors() ? 'error' : ''}`}
                        onChange={props.handleChange}
                        onKeyDown={props.handleKeyDown}
                        onBlur={props.handleOnBlur}
                        onFocus={props.handleOnFocus}
                        autoComplete={props.autoComplete ? props.autoComplete : ''}
                        maxLength={props.maxLength}
                        max={props.max}
                        min={props.min}
                        disabled={props.disabled}
                    />
                    {hasErrors() ? Errors() : ''}
                </div>
            </div>
        </div>
    )
}

InputRow.propTypes = {
    errors: PropTypes.oneOfType([PropTypes.string, PropTypes.object]),
    name: PropTypes.string,
    hideLabel: PropTypes.bool,
    value: PropTypes.oneOfType([PropTypes.string, PropTypes.number, PropTypes.bool]),
    type: PropTypes.string,
    placeholder: PropTypes.string,
    className: PropTypes.string,
    handleChange: PropTypes.func,
    handleKeyDown: PropTypes.func,
    handleOnBlur: PropTypes.func,
    handleOnFocus: PropTypes.func,
    autoComplete: PropTypes.string
}

InputRow.defaultProps = {
    disabled: false
}

export default InputRow



// WEBPACK FOOTER //
// ./resources/js/elements/InputRow.js